import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { lastValueFrom, Observable } from 'rxjs';
import { CustomWindow } from 'app/@types';
import { AppDataService } from 'app/services/app.data.service';
import { JL } from 'jsnlog';

declare let window: CustomWindow;

@Injectable()
export class ApiHttp {
    messageService: MessageService;

    constructor(
        private http: HttpClient,
        private appData: AppDataService) {
        this.messageService = new MessageService();
    }

    public post(
        url: string,
        data?: any,
        messageService?: MessageService,
        postOptions: any = undefined): Promise<any> {
        url = `${window['apiUrl']}${window['apiVersion']}${url}`;

        // toPromise is deprecated in RxJS 7
        //return this.http.post(url, data, { headers }).toPromise()...

        const post$ = this.http.post(url, data, postOptions);

        return lastValueFrom(post$)
            .catch(error => {
                // If error has a response body (like 400 Bad Request with JSON), return it
                // This allows the calling code to handle error responses properly
                if (error && error.error && typeof error.error === 'object') {
                    // Check if it's a structured error response (like LoginResponse with Success: false)
                    if (error.error.Success !== undefined || error.error.error !== undefined || error.error.error_description !== undefined) {
                        return error.error;
                    }
                }

                let msg: any = 'Unknown error';

                let err = error;

                if (error && error.error) {
                    err = error.error;
                }

                if (err) {
                    if (err.ExceptionMessage) {
                        msg = err.ExceptionMessage;
                    }
                    else if (err.Message) {
                        msg = err.Message;
                    }
                    else if (err.message) {
                        msg = err.message;
                    }
                    else if (error.status === 404) {
                        msg = 'File not found';
                    }
                    else if (error.name) {
                        msg = error.name;
                    }

                    // Unauthorized
                    if (error.status === 401 || err.status === 401) {
                        this.appData.logout();
                        return;
                    }
                }

                messageService?.add({ severity: 'error', summary: 'Error', detail: msg });
                JL().warn('HTTP Error: ' + msg);

                // Return undefined for non-structured errors (network errors, etc.)
                return;
            });
    }

    public postDownloadFile(
        url: string,
        data?: any,
        messageService?: MessageService,
        suppressErrorToast = false): Promise<any> {
        const apiUrl = `${window['apiUrl']}${window['apiVersion']}${url}`;
        return lastValueFrom(this.http.post(apiUrl, data, { observe: 'response', responseType: 'blob' }))
            .catch(async error => {
                if (error.status === 401) {
                    this.appData.logout();
                    return { ok: false, ErrorCode: 'UNAUTHORIZED' };
                }
                let message = 'Export failed. Please try again.';
                if (error.status === 404) {
                    message = 'No data found for the selected filters.';
                } else if (error.error instanceof Blob) {
                    const body = await error.error.text();
                    try {
                        const json = JSON.parse(body);
                        message = json.ErrorMessage || json.Message || json.title || json.detail || body || message;
                    } catch {
                        message = body || message;
                    }
                }
                if (!suppressErrorToast) {
                    messageService?.add({ severity: 'error', summary: 'Export failed', detail: message });
                }
                return { ok: false, ErrorMessage: message };
            });
    }

    // TODO: remove it, replace with postDownloadFile
    public postObservable(url: string, data?: any): Observable<any> {
        url = `${window['apiUrl']}${window['apiVersion']}${url}`;

        return this.http.post(url, data, { observe: 'response', responseType: 'blob' });
    }
}
